<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to eDocuments List" @click="$router.push('/hr/edocuments')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn fab small dark color="primary" @click="showAddVersion" title="Add Version">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encoucountered. Please contact support@sweldonow.ph. Details: {{errorMessage}}
            </v-alert>

            <!-- DOCUMENT DETAILS -->
            <v-card v-if="!loading" class="elevation-1 mt-5 mb-5">
                <v-toolbar @click="detailsVisible=!detailsVisible" class="clickable" flat height="45px">
                    <b class="primary--text">DOCUMENT DETAILS</b>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.stop @click="showEditHeader">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                    <v-btn v-if="detailsVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!detailsVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout v-if="detailsVisible" row wrap :class="isMobile?'section-layout-mobile':'section-layout'">
                    <v-flex xs12 sm6 :class="isMobile?'mt-10':'mt-10 mb-10'">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="caption grey--text">Title</div>
                                <div>{{ header.documentTitle }}</div>
                            </v-flex>
                            <v-flex xs12 :class="isMobile?'':'mt-20'">
                                <div class="caption grey--text">Description</div>
                                <div class="mr-20">{{ header.documentDescription }}</div>
                            </v-flex>
                            <v-flex xs12 class="mt-15">
                                <div class="caption grey--text">Current Version</div>
                                <span v-if="header.currentVersionNumber==0">None</span>
                                <v-chip v-else class="ml-0">
                                    {{ header.currentVersionNumber }}
                                </v-chip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm3 :class="isMobile?'mt-10':'mt-10 mb-10'">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="caption grey--text">Category</div>
                                <v-chip class="ml-0">
                                    {{ header.categoryName }}
                                </v-chip>
                            </v-flex>
                            <v-flex xs12>
                                <div class="caption grey--text">Type</div>
                                <v-chip class="ml-0">
                                    {{ header.typeName }}
                                </v-chip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm3 class="mt-10 mb-10">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="caption grey--text">Created By</div>
                                <v-chip class="user-chip-container ml-0">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(header.createdBy.userId)"></v-img>
                                    </v-avatar>
                                    {{header.createdBy.firstName}} {{header.createdBy.lastName}}
                                </v-chip>
                            </v-flex>
                            <v-flex xs12 class="mt-10">
                                <div class="caption grey--text">Created On</div>
                                <div>{{ header.createdOn | moment('MMM DD, YYYY') }}</div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- VERSIONS -->
            <div v-if="versions.length" class="mb-5">
                <v-card v-for="(item, index) in versions" :key="index" class="elevation-1 mt-5">
                    <v-toolbar flat height="45px">
                        <b class="primary--text">VERSION {{ item.versionNumber }}</b>
                        <v-spacer></v-spacer>
                        <v-menu v-if="!loading" left v-model="menu_status" offset-y :disabled="disabled||isCompleted(item)">
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(item.status)" dark v-on="on" :loading="loading_version_btn[index]">
                                    <span class="pr-5 pl-10">{{ commonfn.getStatusDescription(item.status) }}</span>
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile v-show="isDraft(item)||isCancelled(item)" key="0" @click="showEditVersion(item)" title="Edit version">
                                    <v-list-tile-title small>Edit Vesion</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="isDraft(item)||isCancelled(item)" key="1" @click="publish(item, index)" title="Publish document so recipients can view and acknowledge it.">
                                    <v-list-tile-title small>Publish Document</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="isDraft(item)||isPublished(item)" key="2" @click="cancel(item, index)" title="Cancel publication and remove access for recipients.">
                                    <v-list-tile-title small>Cancel Publication</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm4 class="text-xs-center clickable" @click="preview(item)">
                                <v-icon :color="getFileTypeIcon(item.fileType).color" size="150" class="mt-20" title="Click to preview the document">
                                    {{ getFileTypeIcon(item.fileType).icon }}
                                </v-icon>
                                <div class="caption">Click to preview document</div>
                            </v-flex>
                            <v-flex xs12 sm8>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <div class="caption grey--text">Label</div>
                                        <div>{{ item.versionLabel }}</div>
                                    </v-flex>
                                    <v-flex xs12 v-if="item.versionNotes">
                                        <div class="caption grey--text">Notes</div>
                                        <div>{{ item.versionNotes }}</div>
                                    </v-flex>
                                    <v-flex xs12>
                                        <div class="caption grey--text">Recipient Type</div>
                                        <div>{{ getRecipientTypeDescription(item.recipientType) }}</div>
                                    </v-flex>
                                    <v-flex xs12>
                                        <div class="caption grey--text">Response Rate</div>
                                        <v-progress-linear determinate height="25" :value="getOverallPercent(item)" class="caption mt-1">
                                            <div class="pt-3 text-xs-center wp-100">Overall: {{ getOverallProgress(item) }}</div>
                                        </v-progress-linear>
                                        <v-progress-linear determinate height="25" :value="getPerTypePercent(1, item)" class="caption mt-1">
                                            <div class="pt-3 text-xs-center wp-100">Acknowledged and Accepted: {{ getPerTypeProgress(1, item) }}</div>
                                        </v-progress-linear>
                                        <v-progress-linear determinate height="25" :value="getPerTypePercent(2, item)" class="caption mt-1">
                                            <div class="pt-3 text-xs-center wp-100">Acknowledged with Concern: {{ getPerTypeProgress(2, item) }}</div>
                                        </v-progress-linear>
                                        <v-progress-linear determinate height="25" :value="getPerTypePercent(3, item)" class="caption mt-1">
                                            <div class="pt-3 text-xs-center wp-100">Requested Discussion: {{ getPerTypeProgress(3, item) }}</div>
                                        </v-progress-linear>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-data-table
                        :headers="isMobile ? [] : grid_header"
                        :items="item.recipients"
                        :loading="loading"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                        :hide-headers="isMobile"
                    >  
                        <template v-slot:items="props">
                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="grid_header.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-toolbar flat height="42">
                                            <v-chip class="user-chip-container ml-0">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                                </v-avatar>
                                                {{props.item.firstName}} {{props.item.lastName}}
                                            </v-chip>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <v-layout row wrap align-center class="section-layout-mobile">
                                            <v-flex xs12 class="text-xs-left mt-1 mb-1">
                                                <v-layout row>
                                                    <v-flex xs12>
                                                        <div class="caption grey--text">Teams</div>
                                                        <team-chips :teams="props.item.teams"></team-chips>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs7>
                                                        <div class="caption grey--text">Response</div>
                                                        <div :class="getReponseData(props.item.responseTypeId).color">{{ getReponseData(props.item.responseTypeId).description }}</div>
                                                    </v-flex>
                                                    <v-flex xs5 v-if="props.item.responseTypeId>0">
                                                        <div class="caption grey--text">Response Date</div>
                                                        <div v-if="props.item.responseDate">{{ props.item.responseDate | moment('MMM DD, YYYY h:mma') }}</div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row v-if="props.item.employeeRemarks">
                                                    <v-flex xs12>
                                                        <div class="caption grey--text">Employee Remarks</div>
                                                        <div>{{props.item.employeeRemarks}}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>
                                    <v-chip class="user-chip-container ml-0">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                        </v-avatar>
                                        {{props.item.firstName}} {{props.item.lastName}}
                                    </v-chip>
                                </td>
                                <td>
                                    <team-chips :teams="props.item.teams"></team-chips>
                                </td>
                                <td>
                                    <span :class="getReponseData(props.item.responseTypeId).color">{{ getReponseData(props.item.responseTypeId).description }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item.responseDate">{{ props.item.responseDate | moment('MMM DD, YYYY h:mma') }}</span>
                                </td>
                                <td>
                                    {{props.item.employeeRemarks}}
                                </td>
                            </tr>
                        </template>
                    </v-data-table> 
                </v-card>
            </div>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedDocumentId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddEditDocHeader" persistent width="550">
            <add-edit-header ref="refAddEditHeader" :dialogAddEditDocHeader.sync="dialogAddEditDocHeader" @send="getDetails(false)"></add-edit-header>
        </v-dialog>
        <v-dialog v-model="dialogAddEditVersion" persistent width="800">
            <add-edit-version ref="refAddEditVersion" :dialogAddEditVersion.sync="dialogAddEditVersion" @send="getDetails(false)"></add-edit-version>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedDocumentId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import edocumentsApi from '@/api/edocuments'
import awsS3Helper from '@/helpers/aws-s3'
import commonfn from '@/common/functions'   //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import pageKeys from '@/common/pagekeys'
import response_types from '@/constants/edoc-response-types'
import numFormat from '@/common/num_format' //transfer to helpers then expose only method
import { getExpandCollapseVisibility, updateExpandCollapseVisibility } from '@/helpers/user-prefs'
import { getFileTypeIcon } from '@/helpers/file-color-icons'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'

export default {     
    name: 'eDocumentDetails',
    metaInfo: {
        title: 'eDocument Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'eDocument Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'add-edit-header': ()=> import("@/components/EDocuments/AddEditEDocumentHeader"),
        'add-edit-version': ()=> import("@/components/EDocuments/AddEditEDocumentVersion"),
        'preview': () => import('@/components/FilePreview/Preview'),
        'team-chips': () => import("@/components/Common/TeamsChip"),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            awsS3Helper,
            getFileTypeIcon,
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                //bypass any savd sort, on load must always sort by responseDate descending
                sortBy: 'responseDate', 
                descending: true,
            },
            detailsVisible: getExpandCollapseVisibility(this.$route.name, 'document-details'),
            dialogAddEditDocHeader: false,
            dialogAddEditVersion: false,
            dialogPreview: false,
            menu_status: false,
            grid_header: [
                { text: 'Employee', align: 'left', value: 'lastName', width: '20%', sortable: true },
                { text: 'Teams', align: 'left', value: 'teams', width: '20%', sortable: true },
                { text: 'Response', align: 'left', value: 'responseTypeId', width: '20%', sortable: true },
                { text: 'Response Date', align: 'left', value: 'responseDate', width: '20%', sortable: true },
                { text: 'Employee Remarks', align: 'left', value: 'employeeRemarks', width: '20%', sortable: true }
            ],
            //transfer this to constants
            recipient_types: [
                { recipientType: 1, description: 'All Employees' },
                { recipientType: 2, description: 'Selected Teams' },
                { recipientType: 3, description: 'Selected Employees' }
            ],
            error: false,
            errorMessage: '',
            disabled: false,
            loading: false,
            loading_version_btn: [],
            header: null,
            versions: []
        }
    },
    methods: {
        async publish(data, index){
            try {
                this.$set(this.loading_version_btn, index, true)
                
                await edocumentsApi.publishVersion(data)
                await this.getDetails(false)

                this.$set(this.loading_version_btn, index, false)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async cancel(data, index){
            try {
                this.$set(this.loading_version_btn, index, true)
                
                await edocumentsApi.cancelVersion(data)
                await this.getDetails(false)

                this.$set(this.loading_version_btn, index, false)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        isDraft(item){
            return commonfn.getStatusDescription(item.status) == 'Draft'
        },
        isPublished(item){
            return commonfn.getStatusDescription(item.status) == 'Published'
        },
        isCancelled(item){
            return commonfn.getStatusDescription(item.status) == 'Cancelled'
        },
        isCompleted(item){
            return commonfn.getStatusDescription(item.status) == 'Completed'
        },
        async preview(data) {
            const file = {
                name: data.versionLabel,
                type: data.fileType,
                url: '',
                downloadUrl: awsS3Helper.getCompanyDocumentUrl(
                    data.fileName,
                    AWSS3DocumentType.eDocuments
                )
            }

            const requiresSignedUrl = ['WordDocument', 'Pdf'].includes(data.fileType)

            if (requiresSignedUrl) {
                const response = await edocumentsApi.getPreSignedUrl({
                    fileName: data.fileName
                }, pageKeys.edocuments)

                if (!response || response.status !== 200) return

                file.url = response.data
            } else {
                file.url = file.downloadUrl
            }

            this.$refs.refPreviewComponet.setParams(file)
            this.dialogPreview = true
        },
        showAddVersion() {
            this.$refs.refAddEditVersion.setAdd(this.header)
            this.dialogAddEditVersion = true
        },
        showEditVersion(data) {
            this.$refs.refAddEditVersion.setEdit(data)
            this.dialogAddEditVersion = true
        },
        showEditHeader() {
            this.$refs.refAddEditHeader.setEdit(this.header)
            this.dialogAddEditDocHeader = true
        },
        getRecipientTypeDescription(recipientType) {
            return this.recipient_types.find(x => x.recipientType == recipientType).description
        },
        async getDetails(show_loading) {
            try {
                this.loading = show_loading
                const response = await edocumentsApi.getDetails(this.selectedDocumentId)
                if (response && response.status == 200) {
                    this.header = response.data.header
                    this.versions = response.data.versions
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        getOverallProgress(item){
            const responded = item.recipients.filter(x => x.responseTypeId > 0).length
            const responder = item.recipients.length
            const percent = (responded / responder) * 100
            return `${responded} of ${responder} (${numFormat.formatNumber(percent)} %)`
        },
        getOverallPercent(item) {
            const responded = item.recipients.filter(x => x.responseTypeId > 0).length
            const responder = item.recipients.length
            const percent = (responded / responder) * 100
            return percent
        },
        getPerTypeProgress(type,item){
            const responded = item.recipients.filter(x => x.responseTypeId == type).length
            const responder = item.recipients.length
            const percent = (responded / responder) * 100
            return `${responded} of ${responder} (${numFormat.formatNumber(percent)} %)`
        },
        getPerTypePercent(type,item){
            const responded = item.recipients.filter(x => x.responseTypeId == type).length
            const responder = item.recipients.length
            const percent = (responded / responder) * 100
            return percent
        },
        getReponseData(responseTypeId){
            return response_types.find(x => x.responseTypeId == responseTypeId)
        },
        updateHandler(userId) {
            //exclude the the device/user who initiates the update
            if (userId!=this.$store.state.userId) 
                this.getDetails(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'eDocument Details'
        })

        this.getDetails(true)
    },
    watch: {
         detailsVisible(newVal) {
            updateExpandCollapseVisibility(this.$route.name, 'document-details', newVal)
        },
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedDocumentId() {
            return this.$route.params.documentId
        },
        commentsData() {
            return {
                pageQueryId: this.selectedDocumentId,
                
                //these are used to notify other users when adding comment
                //this is for refactor. see dev tasks.
                pageItemCreatedBy: null,
                pageLink: null,
                pageKey: null,
                notificationTypeId: null,
            }
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 25px 0px 50px;
}
.section-layout-mobile {
    padding:0px 20px 0px 20px;
}
.icon-wrapper {
  display: inline-flex;
  padding: 20px;
  border-radius: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.icon-wrapper:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15);
}
.pdf-icon {
  font-size: 64px;
}
</style>